import { type MouseEvent, useCallback } from 'react';

export const useOverlayClickHandler = (onClose: () => void) => {
  return useCallback(
    (event: MouseEvent<HTMLElement>) => {
      if (event.target === event.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );
};
